"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('filter-one', true, function (props) {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.489 8.3975C24.2457 8.35865 24.2742 8 24.5205 8H39.5C39.7761 8 40 8.22386 40 8.5V23.4795C40 23.7258 39.6414 23.7543 39.6025 23.511L37.6355 11.1943C37.5673 10.7674 37.2326 10.4327 36.8057 10.3645L24.489 8.3975Z",
    fill: props.colors[0],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.489 26.3975C6.24574 26.3586 6.2742 26 6.52054 26H21.5C21.7761 26 22 26.2239 22 26.5V41.4795C22 41.7258 21.6414 41.7543 21.6025 41.511L19.6355 29.1943C19.5673 28.7674 19.2326 28.4327 18.8057 28.3645L6.489 26.3975Z",
    fill: props.colors[0],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.489 17.3975C15.2457 17.3586 15.2742 17 15.5205 17H30.5C30.7761 17 31 17.2239 31 17.5V32.4795C31 32.7258 30.6414 32.7543 30.6025 32.511L28.7498 20.9098C28.6134 20.0561 27.9439 19.3866 27.0902 19.2502L15.489 17.3975Z",
    fill: props.colors[0],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;